<template>
  <div
    v-if="showBanner"
    class="hj-plus-upgrade-banner mb-4"
    @click="showHJPBillingProfileDialog({ value: true })"
  >
    <v-icon class="hj-plus-upgrade-banner__icon">mdi-information</v-icon>
    <span>{{ bannerText }}</span>
    <v-btn
      small
      color="#0d4c8b"
      class="hj-plus-upgrade-banner__btn white--text ml-2"
      @click.stop="showHJPBillingProfileDialog({ value: true })"
    >
      {{ buttonText }}
    </v-btn>
  </div>
</template>

<script>
import getCurrentUserX from '@/mixins/getCurrentUserX'
import housejetplus from '@/mixins/housejetplus'
import { FeatureFlags } from '@/options/featureFlags'

export default {
  name: 'HJPlusUpgradeBanner',
  mixins: [getCurrentUserX, housejetplus],

  computed: {
    showBanner() {
      if (!this.ppc || this.isFreeSignup) return false
      if (!this.currentUserCanUse(FeatureFlags.KEY_HJ_PLUS_UPGRADE_BANNER)) return false
      return !this.HouseJetMembershipActive
    },

    trialDays() {
      return this.currentUser?.house_jet_membership?.days_until_due_for_trial ?? 0
    },

    bannerText() {
      const trialUsed = Number(this.currentUser?.house_jet_membership?.trial_used) === 1

      if (this.trialDays > 0 && !trialUsed) {
        return `Start your ${this.trialDays} day trial of HOUSEJET+`
      }

      return 'Upgrade to HOUSEJET+'
    },

    buttonText() {
      return this.trialDays > 0 && !this.trialUsed ? 'Start Trial' : 'Upgrade'
    },
  },
}
</script>

<style scoped>
.hj-plus-upgrade-banner {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 6px 16px;
  margin-bottom: 16px;
  margin-left: 16px;
  margin-right: 16px;
  border: 1px solid #b6dbf7;
  border-radius: 6px;
  background-color: var(--secondary-background);
  color: #0d4c8b;
  font-weight: 600;
  font-size: 1rem;
  cursor: pointer;
  transition: background-color 0.15s ease, box-shadow 0.15s ease;
}


.hj-plus-upgrade-banner:hover {
  background-color: #ddeefb;
  box-shadow: 0 1px 4px rgba(13, 76, 139, 0.15);
}

.hj-plus-upgrade-banner:focus-visible {
  outline: 2px solid #1e88e5;
  outline-offset: 2px;
}

.hj-plus-upgrade-banner__icon.v-icon {
  color: #1e88e5;
  font-size: 22px;
}

.hj-plus-upgrade-banner__close.v-icon {
  color: #6b93b8;
  font-size: 20px;
}

@media (max-width: 960px) {
  .hj-plus-upgrade-banner {
    font-size: 0.95rem;
  }
}
</style>
